module.exports = __webpack_public_path__ + "media/images/photo1-65aff8fd4846c191d89fd948ee1f221c.jpg";